
import Mmenu from "mmenu-js"
import "mmenu-js/dist/mmenu.css"

import Utils from "@/module/utils/utils"
import Component, { ComponentMethods } from "@/module/component/component"
import Cache from "@/module/cache/cache"
import Href from "@/module/config/href"
import Theme from "@/module/theme/theme"
import Message from "@/module/interactive/message"

import elemIcon from "@/components/elem-icon.vue"
import elemOptions from "@/components/elem-options.vue"
import compMenu from "@/components/comp-menu.vue"
import pageAbout from "@/components/page-about.vue"

import Version from "@/module/version/version"

class Framework {
    private static index: IndexView

    public static setTitle(title: string, icon?: string): void {
        this.index.page_title = title
        this.index.page_icon = icon || "data"
    }

    public static setIndex(index: IndexView) {
        this.index = index
    }
}

class IndexView extends ComponentMethods implements ComponentEntity {
    public page_title: string = "首页"

    public page_icon: string = "data"

    public d_menu_root: string = null

    public menus: MenuObj[] = null

    public submenus = null

    public userMenu = [
        {
            title: "账号管理",
            sub: [
                {
                    id: "edit_password",
                    icon: "password",
                    name: "修改密码",
                },
                {
                    id: "sign_out",
                    icon: "sign_out",
                    name: "退出登录",
                },
            ],
        },
    ]

    public settingMenu = [
        {
            title: "主题",
            prompt: "自动模式下，将根据系统主题自动切换浅色模式或深色模式。",
            sub: [
                {
                    id: "auto_theme",
                    icon: "auto",
                    name: "自动模式",
                },
                {
                    id: "light_theme",
                    icon: "light",
                    name: "浅色模式",
                },
                {
                    id: "dark_theme",
                    icon: "dark",
                    name: "深色模式",
                },
            ],
        },
        {
            title: "系统",
            sub: [
                {
                    id: "update",
                    icon: "update",
                    name: "检查更新",
                },
                {
                    id: "version",
                    icon: "about",
                    name: "版本",
                },
            ],
        },
    ]

    data() {
        return {
            online_service_user_id_activity: null,

            // 是否显示在线服务页面
            isDisplayOnlineServicePage: false,

            // 在线服务菜单
            online_service_menu: "new",

            chats: [
                {
                    isCurrent: false,
                    type: "user",
                    name: "晟浩科技",
                    date: "2019-08-22 10:00",
                    content: "测试内容",
                },
                {
                    isCurrent: true,
                    type: "admin",
                    name: "晟浩科技",
                    date: "2019-08-22 10:00",
                    content: "测试内容",
                },
            ],

            search_result: null,

            display_search: false,

            setting_info: Cache.get("setting_info"),

            userinfo: Cache.get("userinfo"),
        }
    }

    components = {
        elemIcon,
        compMenu,
        elemOptions,
        pageAbout,
    }

    watch = {
        $route: async function (to) {
            this.processRoute(to)
        },
    }

    created() {
        Framework.setIndex(this)

        Href.get().then(res => {
            this.menus = Utils.copy(res.menus)
            this.submenus = Utils.copy(res.submenus)

            setTimeout(() => {
                this._setMenuChildBoxStyle()

                this.menu = new Mmenu("#menu-mobile", {
                    theme: "dark",
                })

                // 为所有菜单链接绑定点击事件，点击后关闭菜单
                const menuLinks = document.querySelectorAll("#menu-mobile a[child]")
                menuLinks.forEach(link => {
                    link.addEventListener("click", () => {
                        this.menu.close()
                    })
                })
            })
        })

        Cache.onGet("userinfo", v => {
            this.userinfo = v
        })
    }

    mounted() {
        this.processRoute()
    }

    beforeDestroy() {
        this.menu?.destroy()
    }

    /**
     * 监听窗口大小变化事件
     */
    onResize() {
        this._setMenuChildBoxStyle()
    }

    /**
     * 监听内容组件滚动事件
     */
    onScroll(evt: obj): void {
        const e: HTMLDivElement = evt.target
        var wScrollY = e.scrollTop // 当前滚动条位置
        var wInnerH = e.clientHeight // 设备窗口的高度（不会变）
        var bScrollH = e.scrollHeight // 滚动条总高度
        if (wScrollY + wInnerH >= bScrollH - 20) {
            const page = this.$route.matched[0].instances.default
            // 触发触底事件
            page.onReachBottom && page.onReachBottom()
        }
    }

    processRoute(route?: obj) {
        // 关闭所有消息框
        Message.closeAll()

        Utils.wait(() => {
            if (typeof route === "undefined") {
                route = this.$route
            }

            if (route.matched.length <= 0) {
                return
            }

            const page = route.matched[0].instances.default
            // 设置页面标题
            this.page_title = (typeof page.title === "function" ? page.title() : page.title) || "首页"
            // 设置页面图标
            this.page_icon = page.icon || "data"
            // 写入框架方法
            if (typeof page.framework === "undefined") {
                page.framework = Framework
            }
            // 触发 onLoad 事件
            page.onLoad && page.onLoad(page.getParams())
        })
    }

    onSelectSettingMenu(evt: CompEvent<any>) {
        switch (evt.value) {
            case "auto_theme":
                Theme.changeTheme("auto")
                break
            case "dark_theme":
                Theme.changeTheme("dark")
                break
            case "light_theme":
                Theme.changeTheme("light")
                break
            case "update":
                Version.check()
                break
            case "version":
                Version.get().then(res => {
                    Message.info(`管理端版本：${res.admin}，框架版本：${res.framework}`)
                })
        }
    }

    /** 设置子菜单样式 */
    private _setMenuChildBoxStyle() {
        Utils.getElementAll<HTMLDivElement>(".menu-child-base", e => {
            const p = e.getBoundingClientRect()

            if (p.height + p.y + 100 > window.innerHeight) {
                if (!e.classList.contains("menu-child-box-bottom")) {
                    e.classList.add("menu-child-box-bottom")
                }
            } else {
                if (e.classList.contains("menu-child-box-bottom")) {
                    e.classList.remove("menu-child-box-bottom")
                }
            }
        })
    }

    /**
     * 获取子菜单模板
     * @param child 子菜单
     * @param isBase 是否添加 base
     */
    public getMenuChild(child: MenuObj[], isBase?: boolean): string {
        var childs = ""

        Utils.each(child, v => {
            childs += `
                <div class="menu-child-item">
                    <a class="menu-child-item-box" ${v.href ? 'href="' + v.href + '" @click="hideMenuChild()"' : ""}>
                        <img class="menu-child-icon" src="static/icon/menu_icon/${v.icon}" />
                        <p class="menu-child-name">${v.name}</p>
                        ${v.child ? '<img class="arrow-icon" src="static/icon/arrow_right_blue.svg" />' : ""}
                    </a>
                    ${v.child ? this.getMenuChild(v.child, true) : ""}
                </div>
            `
        })

        const box = `<div class="menu-child-box">${childs}</div>`

        return isBase ? `<div class="menu-child-base">${box}</div>` : box
    }

    /**
     * 获取移动端子菜单模板
     * @param child 子菜单
     */
    public getMobileMenuChild(child: MenuObj[], isBase?: boolean): string {
        var childs = ""

        Utils.each(child, v => {
            childs += `
                <li>
                    <a ${v.href ? 'href="' + v.href + '"' : ""} child>${v.name}</a>
                    ${v.child ? this.getMobileMenuChild(v.child, true) : ""}
                </li>
            `
        })

        return isBase ? `<ul>${childs}</ul>` : childs
    }

    public hideMenuChild() {
        const dom = document.querySelectorAll<HTMLDivElement>(".menu-child-box")

        if (dom.length > 0) {
            Utils.eachNode(dom, v => {
                v.hidden = true
                // 使用延时将子菜单可显示状态
                setTimeout(() => {
                    v.hidden = false
                }, 100)
            })
        }
    }

    /**
     * 监听用户菜单
     * @param evt 值
     */
    onSelectUserMenu(evt: obj): void {
        const value = evt.value

        switch (value) {
            case "sign_out":
                Message.info("确认退出当前账号？", true)
                    .onConfirm(() => {
                        // 移除所有缓存
                        Cache.clear()
                        // 刷新页面
                        window.location.reload()
                    })
                    .build()
                break
            case "edit_password":
                this.jump("/table?name=AdminAccount")
        }
    }

    /**
     * 监听搜索框聚焦事件
     */
    onSearchInputFocus() {
        this.display_search = true
    }

    /**
     * 监听搜索框失焦事件
     */
    onSearchInputBlur() {
        setTimeout(() => {
            this.display_search = false
        }, 200)
    }

    /**
     * 监听搜索框变化事件
     * @param evt event
     */
    async onSearchInput(evt: InputEvent) {
        const node: HTMLInputElement = Utils.getNode(evt)

        var val = node.value
        console.log(val)
        const pages: obj[] = (await Href.get()).pages
        console.log(pages)

        if (!val) {
            this.search_result = []
            return
        }

        this.search_result = pages.filter(v => v.title.includes(val))
    }

    /**
     * 监听搜索框提交事件
     */
    onSearchSubmit() {
        if (!this.search_result || this.search_result.length <= 0) {
            Message.info("暂无搜索结果")
        }
    }
}

interface MenuObj {
    icon: string
    href?: string
    root?: string
    component?: string
    name?: string
    child?: MenuObj[]
}

export default Component.build(new IndexView())
